<template>
    <!-- ========================== -->
    <!-- ABOUT - HEADER -->
    <!-- ========================== -->
    <section class="top-header about-header with-bottom-effect transparent-effect dark">
        <div class="bottom-effect"></div>
        <div class="header-container">
            <div class="header-title wow fadeInUp">
                <div class="header-icon"><span class="icon icon-Wheelbarrow"></span></div>
                <div class="title">{{ pageTitle }}</div>
                <em>{{ pageSubtitle }}</em>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'TopHeader',
    props: {
        pageTitle: String,
        pageSubtitle: String
    },
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/TopHeader.vue